import { plainToClass } from "class-transformer";
import { Appendix } from "../../../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../../../shared/entities/scripts/study";
import { FilterOption } from "../../../../../../shared/scripts/filtering/filtering.entities";
import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { SiteInfo } from "../../../../sites/shared/sites.entities";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { Intervention, InterventionEvent } from "./interventions.entities";
import { InterventionsSummaryView } from '../interventions-summary-view/interventions-summary-view'
import { InterventionsDatatableView } from "../interventions-datatable-view/interventions-datatable-view";
import { InterventionsLookup } from "./interventions.lookup";
import { InterventionsDatatableEntry } from "../interventions-datatable-view/interventions-datatable-entities";
import { InterventionsSummarySeries } from "../interventions-summary-view/interventions-summary-entities";


export class InterventionsController {
    siteInfo: ISiteInfo;

    allInterventions: Intervention[] = [];
    allInterventionEvents: InterventionEvent[] = [];

    summaryView: InterventionsSummaryView;
    datatableView: InterventionsDatatableView;

    constructor(siteInfo: ISiteInfo, interventionsJson: any) {
        
        this.siteInfo = siteInfo;

        let foundIds: number[] = [];
        this.allInterventionEvents = plainToClass(InterventionEvent, <InterventionEvent[]>interventionsJson);
        this.allInterventionEvents.forEach((o: InterventionEvent) => {
            //o.initialize()
            if (!foundIds.includes(o.AppendixId)) {
                this.allInterventions.push(new Intervention(o.AppendixId, InterventionsLookup.GetInterventionStatus(o.InterventionStatusId), InterventionsLookup.GetInterventionOrdering(o.InterventionStatusId)));
                foundIds.push(o.AppendixId);
            }
        });
        this.allInterventions.sort((a: Intervention, b: Intervention) => a.OrderBy - b.OrderBy);

        this.summaryView = new InterventionsSummaryView();
        this.datatableView = new InterventionsDatatableView();

        $("#intervention-summary-overall-btn").addClass("active");
        $("#intervention-datatable-none-btn").addClass("active");
    }

    //todo: set up filter updated functionality
    FilterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[]): void {
        
        let bySiteSummaryMap: Map<number, InterventionsSummarySeries> = new Map<number, InterventionsSummarySeries>();
        let byOverallSummaryMap: Map<number, InterventionsSummarySeries> = new Map<number, InterventionsSummarySeries>();

        let groupingNoneMap: Map<string, InterventionsDatatableEntry> = new Map<string, InterventionsDatatableEntry>();
        let groupingBySiteMap: Map<string, InterventionsDatatableEntry> = new Map<string, InterventionsDatatableEntry>();

        for (let i = 0; i < this.allInterventionEvents.length; ++i) {
            let intervention: InterventionEvent = this.allInterventionEvents[i];

            if (!studyIds.includes(intervention.StudyId) || !appendixIds.includes(intervention.AppendixId) ||
                !siteIds.includes(intervention.SiteNumber)) continue;

            let interventionOverallSeries: InterventionsSummarySeries;
            if (byOverallSummaryMap.has(intervention.AppendixId)) { interventionOverallSeries = byOverallSummaryMap.get(intervention.AppendixId); }
            else { interventionOverallSeries = new InterventionsSummarySeries(Appendix.GetAppendixName(intervention.AppendixId), "intervention", intervention.AppendixId); }
            interventionOverallSeries.addInterventionEvent(intervention);
            byOverallSummaryMap.set(intervention.AppendixId, interventionOverallSeries);


            let interventionSiteSeries: InterventionsSummarySeries;
            if (bySiteSummaryMap.has(intervention.SiteNumber)) { interventionSiteSeries = bySiteSummaryMap.get(intervention.SiteNumber); }
            else { interventionSiteSeries = new InterventionsSummarySeries(this.siteInfo.GetSiteName(intervention.SiteNumber), "site", intervention.SiteNumber) }
            interventionSiteSeries.addInterventionEvent(intervention);
            bySiteSummaryMap.set(intervention.SiteNumber, interventionSiteSeries);


            let dataHash: string;

            let noneData: InterventionsDatatableEntry;
            dataHash = InterventionsDatatableEntry.getHash("none", intervention);
            if (groupingNoneMap.has(dataHash)) { noneData = groupingNoneMap.get(dataHash); }
            else { noneData = new InterventionsDatatableEntry(Study.GetStudyName(intervention.StudyId), Appendix.GetAppendixName(intervention.AppendixId), this.siteInfo.GetSiteName(intervention.SiteNumber), SiteInfo.FormatSiteNumber(intervention.SiteNumber))}
            noneData.addInterventionEvent(intervention);
            groupingNoneMap.set(dataHash, noneData);


            let siteData: InterventionsDatatableEntry;
            dataHash = InterventionsDatatableEntry.getHash("by-site", intervention);
            if (groupingBySiteMap.has(dataHash)) { siteData = groupingBySiteMap.get(dataHash); }
            else { siteData = new InterventionsDatatableEntry(Study.GetStudyName(intervention.StudyId), Appendix.GetAppendixName(intervention.AppendixId), this.siteInfo.GetSiteName(intervention.SiteNumber), SiteInfo.FormatSiteNumber(intervention.SiteNumber)); }
            siteData.addInterventionEvent(intervention);
            groupingBySiteMap.set(dataHash, siteData);

        }


        let seriesBySite: InterventionsSummarySeries[] = [...bySiteSummaryMap.values()];

        let seriesByOverall: InterventionsSummarySeries[] = [...byOverallSummaryMap.values()];

        this.summaryView.UpdateData(seriesByOverall, seriesBySite);



        let tableEntriesNone: InterventionsDatatableEntry[] = [...groupingNoneMap.values()];
        for (let i: number = 0; i < tableEntriesNone.length; i++) { tableEntriesNone[i].initialize(); }

        let tableEntriesBySite: InterventionsDatatableEntry[] = [...groupingBySiteMap.values()];
        for (let i: number = 0; i < tableEntriesBySite.length; i++) { tableEntriesBySite[i].initialize(); }

        this.datatableView.UpdateData(tableEntriesNone, tableEntriesBySite);
    }

    setView(newView: string): void {
        if (newView == "view-summary") {
            SetActiveTab("interventions-tabs", "interventions-summary-content");
            this.summaryView.SetView("interventions-summary");
        } else if (newView == "view-datatable") {
            SetActiveTab("interventions-tabs", "interventions-datatable-content");
            this.datatableView.SetView("interventions-datatable");
        } else {
            this.summaryView.SetView(newView);
            this.datatableView.SetView(newView);
        }
    }
}